import { ActionBasic } from 'kts-scaffold-framework/modules';
import { userCenter } from 'src/api';
import ModulesState from './Modules.State';
import { history } from 'kts-platform-frame/routes';
import { passConfig } from 'kts-platform-frame/utils';
import { passwordRule, guide, system } from 'src/api';
import { company } from 'kts-platform-frame/api';
import { message } from 'antd';
import job from 'src/api/systemManage/job';
import { MyStore, reducers } from 'kts-platform-frame/redux';

class ModulesAction extends ActionBasic<ModulesState> {

    /** 邀请登录设置密码，验证 ticket */
    public resetPsw = async (newPwd: string, oldPwd: string) => {

        const param = {
            newPwd: newPwd,
            oldPwd: oldPwd,
        };

        const data = await userCenter.resetPwd(this, param);
        if (data.er) {
            return false;
        }
        return true;
    }

    public passConfigGet = async () => {
        const res = await passwordRule.passConfigGet(this);
        if (!res.er) {
            let str = '';
            this.modulesState.passConfig = res.res;
            const passConfigArr = passConfig(res.res, '');
            this.changePassConfigArr(passConfigArr);
            passConfigArr.forEach(ele => {
                str += ele['message'] + ',';
            });
            str = str.slice(0, str.length - 1);
            this.modulesState.newPasTipMessage = str;
            this.setModulesState();
        }
    }

    public changeNewPasTipView = (b) => {
        this.modulesState.newPasTipView = b;
        this.setModulesState();
    }

    public changePassConfigArr = (option) => {
        this.modulesState.passConfigArr = option;
        this.setModulesState();
    }

    public changePassConfigArrView = (b) => {
        this.modulesState.passConcigArrView = b;
        this.setModulesState();
    }

    public changeNewPasTipMessage = (str) => {
        this.modulesState.newPasTipMessage = str;
        this.setModulesState();
    }

    public updatePassword = async (opt) => {
        const res = await passwordRule.changeByEmail(this, opt);
        if (!res.er) {
            history.push(`/`);
        }
    }

    public updateConfirmDirty = () => {
        this.modulesState.confirmDirty = true;
        this.setModulesState();
    }
    /** 
     * 获取登录相关信息
     */
    public getCurrentAccountInfo = async () => {
        const res = await guide.getCurrentAccountInfo(this, {});
        if (res.er) {
            return false;
        }
        this.modulesState.accountInfo = res.res;
        this.setModulesState();
    }
    /** 修改电话弹框--打开 */
    public openChangePhoneM = (phone) => {
        this.modulesState.changePhoneNum = phone;
        this.modulesState.stepChangePhone = 1;
        this.modulesState.visibleChangePhoneM = true;
        this.setModulesState();
    }
    /** 修改电话弹框--关闭 */
    public closeChangePhoneM = () => {
        this.modulesState.stepChangePhone = 1;
        this.modulesState.visibleChangePhoneM = false;
        this.modulesState.changePhoneNum = undefined;
        this.setModulesState();
    }
    /** 验证密码 */
    public verificationPassword = async (val) => {
        const res = await passwordRule.passIsLegal(this, {
            password: val.password,
        });
        if (res.er) {
            let errTip = res.er.body ? res.er.body.status ? res.er.body.status.description : '验证失败' : '验证失败';
            message.error(errTip);
            return false;
        }
        // 验证成功下一步
        this.modulesState.credential = val.password;
        this.modulesState.validateCodeKey = undefined;
        this.modulesState.validateSending = false;
        this.modulesState.stepChangePhone = 2;
        this.modulesState.verificationCounter = 0;
        this.setModulesState();
    }
    
    /** 修改手机 */
    public changePSD = async (val) => {
        let validateCodeKey = this.modulesState.validateCodeKey;
        if (!validateCodeKey) {
            message.warning('请先获取手机验证码');
            return false;
        }
        const res = await passwordRule.phoneUpdate(this, {
            credential: this.modulesState.credential,
            phone: val.phone,
            validateCode: val.validateCode,
            validateCodeKey: this.modulesState.validateCodeKey,
        });
        if (res.er) {
            let errTip = res.er.body ? res.er.body.status ? res.er.body.status.description : '验证失败' : '验证失败'; 
            message.error(errTip);
            return false;
        }
        this.getCurrentAccountInfo();
        this.modulesState.stepChangePhone = 3;
        this.modulesState.verificationCounter = 0;
        this.setModulesState();
    }
    /**
     * 发送手机号验证
     */
    public sendPhone = async (val) => {
        this.modulesState.validateSending = true;
        this.setModulesState();
        const res: any = await passwordRule.validateCode(this, {
            complexType: 2,
            phone: val.phone,
            createValidateCodeRequest: {
                bussCode: "change_phone",
                bussKey: val.phone,
            },
        });
        this.modulesState.validateSending = false;
        this.setModulesState();
        if (!res.er) {
            this.modulesState.validateCodeKey = res.res.createValidateCodeResponse ? res.res.createValidateCodeResponse.validateCodeKey : undefined;
            this.setModulesState();
            this.countDown();
        }
        
    }
    /** 倒计时 */
    public countDown = () => {
        this.modulesState.verificationCounter = 60;
        this.setModulesState(this.modulesState, () => {
            let setInterv = setInterval(() => {
                if (this.modulesState.verificationCounter <= 0) {
                    clearInterval(setInterv);
                }
                this.modulesState.verificationCounter = this.modulesState.verificationCounter - 1;
                this.setModulesState();
            }, 1000);
        });

        this.setModulesState();
    }

    /**
     * 修改联系 手机/邮箱 弹框打开
     */
    public changContactType = (type: string, value: string): void => {
        this.modulesState.changContactVisibleM = true;
        this.modulesState.changContactValue = value;
        this.modulesState.changContactType = type;
        this.setModulesState();
    }
    /**
     * 修改联系 手机/邮箱 弹框关闭
     */
    public closeChangContactM = () => {
        this.modulesState.changContactVisibleM = false;
        this.setModulesState();
    }
    /** 修改联系方式 */
    public userEdit = async (val) => {
        const { user } = MyStore.instance.getState();

        // 接口调用
        let data = await system.userEdit(this, {
            ...val,
            userId: user.userInfo.cUserId
        });
        if (data.er) {
            message.error('修改失败');
            return;
        }
        
        // 更新 redux 全局数据
        await company.userInfo(window);

        message.success('修改成功');
        this.closeChangContactM();
    }
}

export default new ModulesAction();



// WEBPACK FOOTER //
// ./src/display/platform/UserCenter/Modules.Action.ts